import { useLang } from "@/i18n/LanguageContext";
import { Shield, Lock, FileCheck, CreditCard } from "lucide-react";

const icons = [Shield, Lock, FileCheck, CreditCard];

const TrustBlock = () => {
  const { t } = useLang();
  return (
    <section className="py-20 md:py-24 bg-secondary">
      <div className="container">
        <div className="max-w-3xl">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-primary-glow">{t.trust.eyebrow}</span>
          <h2 className="mt-3 text-3xl sm:text-4xl md:text-5xl font-extrabold leading-[1.05]">{t.trust.title}</h2>
          <p className="mt-4 text-lg text-muted-foreground">{t.trust.desc}</p>
        </div>
        <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {t.trust.items.map((item, i) => {
            const Icon = icons[i] ?? Shield;
            return (
              <div key={item.t} className="rounded-2xl bg-background p-6 shadow-card">
                <div className="h-10 w-10 rounded-xl bg-primary text-primary-foreground flex items-center justify-center">
                  <Icon className="h-5 w-5" />
                </div>
                <div className="mt-4 text-base font-extrabold">{item.t}</div>
                <p className="mt-1 text-sm text-muted-foreground leading-relaxed">{item.d}</p>
              </div>
            );
          })}
        </div>
        <p className="mt-8 text-sm text-muted-foreground">{t.trust.availability}</p>
      </div>
    </section>
  );
};

export default TrustBlock;
